import type { ComponentProps, ComponentType } from "react";
import { createContext, useContext } from "react";

export type PictureSource = {
  srcSet?: string;
  media?: string;
  type?: string;
};

export type PictureWrapperProps = {
  className?: string;
  sources: PictureSource[];
  imageProps: ComponentProps<"img"> & { "data-testid"?: string };
};

export const PictureBehaviourContext = createContext<ComponentType<PictureWrapperProps> | null>(null);

export const usePicture = () => {
  return useContext(PictureBehaviourContext);
};
